import '.bi{flex-shrink:0;}.ssr-plugin'
import '.bk{padding:1rem;}.ssr-plugin'
import '.a0{width:100%;}.ssr-plugin'
import '.bj{height:100%;}.ssr-plugin'
import '.b9{border:none;}.ssr-plugin'
import '.ba{background-color:transparent;}.ssr-plugin'
import '.fa{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.de{position:sticky;}.ssr-plugin'
import '.fb{top:4rem;}.ssr-plugin'
import '.fc{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fd{padding-bottom:1rem;}.ssr-plugin'
import '.q{margin-bottom:1rem;}.ssr-plugin'
import '.fe{border-bottom:var(--blue-border);}.ssr-plugin'
import '.u{position:fixed;}.ssr-plugin'
import '.cr{top:0;}.ssr-plugin'
import '.bm{left:0px;}.ssr-plugin'
import '.bn{right:0px;}.ssr-plugin'
import '.ff{bottom:0px;}.ssr-plugin'
import '.e9{z-index:9999;}.ssr-plugin'
import '.fg{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cq{justify-content:flex-end;}.ssr-plugin'
import '.bl{flex:1;}.ssr-plugin'
import '.ar{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bi bk a0 bj b9 ba fa"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a b ab"
    >
      <div className="de fb fc ae fd q fe a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="u cr bm bn ff e9 ae fg a b"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bk a cq fe"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bl ar">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
